export default __webpack_public_path__ + "static/media/UniversLTStd-ExObl.fb2b8a00.otf";